import React, { useState, useEffect } from 'react';

const AddEditServiceCategory = ({ onSubmit, data }) => {
  const [name, setName] = useState('');
  const [logo, setLogo] = useState('');
  const [logoPreview, setLogoPreview] = useState('');

  // Handle file input change and convert to Base64
  const handleLogoChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setLogo(reader.result);
        setLogoPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  // Handle form submission
  const handleSubmit = (event) => {
    event.preventDefault();
    onSubmit({ name, logo });
  };

  // Update state when `data` changes
  useEffect(() => {
    if (data) {
      console.log(data.logo)
      setName(data.name || '');
      setLogo(data.logo || '');
      setLogoPreview(data.logo || '');
    }
  }, [data]);

  return (
    <form onSubmit={handleSubmit}>
      <div className="mb-3">
        <label htmlFor="name" className="form-label">Service Category Name</label>
        <input
          type="text"
          className="form-control"
          id="name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
      </div>

      <div className="mb-3">
        <label htmlFor="logo" className="form-label">Logo</label>
        <input
          type="file"
          className="form-control"
          id="logo"
          accept="image/*"
          onChange={handleLogoChange}
          required={!data} // Require file input only for new entries
        />
        {logoPreview && (
          <div className="mt-3">
            <img src={logoPreview} alt="Logo Preview" className="img-thumbnail" style={{ maxWidth: '150px' }} />
          </div>
        )}
      </div>

      <button type="submit" className="btn btn-primary">
        {data ? 'Update' : 'Submit'}
      </button>
    </form>
  );
};

export default AddEditServiceCategory;
